import React, { useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, Box
} from '@mui/material';

interface ModalDataProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (dataSelecionada: string) => void;
}

export const ModalData: React.FC<ModalDataProps> = ({
    open,
    onClose,
    onSubmit,
}) => {
    const [dataSelecionada, setDataSelecionada] = useState<string>('');

    const handleSubmit = () => {
        onSubmit(dataSelecionada);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Selecionar Data para o Gráfico</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2 }}>
                    <TextField
                        type="date"
                        label="Data e hora de leitura"
                        fullWidth
                        value={dataSelecionada}
                        onChange={(e) => setDataSelecionada(e.target.value)}
                        InputLabelProps={{ shrink: true }}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancelar</Button>
                <Button onClick={handleSubmit} variant="contained">
                    Aplicar Data
                </Button>
            </DialogActions>
        </Dialog>
    );
};